import React from 'react';
import {Badge} from 'antd';
import cn from 'classnames';

import { LINK_TELEGRAM} from '../../config/routes';

import cls from './Contacts.module.scss'

export const Contacts = () => (
    <div className={cn(['half', cls.page])}>

        <h1>Контакты</h1>

        <div className={cls.block}>
            <h2>Будем рады сотрудничеству!</h2>
            <div className={cls.table}>
                <div>Телефон</div>
                <div><a href={'tel:+79104280272'} target={'_blank'} rel={'noreferrer'}>+7 (910) 428-02-72</a></div>
                <div>Email</div>
                <div><a href={'mailto:info@daisycandels.ru'} target={'_blank'} rel={'noreferrer'}>info@daisycandels.ru</a></div>
                <div>Telegram</div>
                <div><a href={LINK_TELEGRAM} target={'_blank'} rel={'noreferrer'}>DAISY store_candles</a></div>
            </div>
        </div>

        <div className={cls.block}>
            <h2>Пункты выдачи заказов</h2>
            <div><Badge color={'#E08E79'} count={1}/> Москва, Римского-Корсакова, 11</div>
            <div><Badge color={'#E08E79'} count={2}/> МО, Солнечногорский район, КП&nbsp;«Тихие&nbsp;Зори»</div>
            <div>
                <iframe
                    src="https://yandex.ru/map-widget/v1/?um=constructor%3A822c5202ac9e7243bf94caa79f188711ab1aed3cfc750447c71177333fcfe07b&amp;source=constructor"
                    style={{width: '100%'}} height="300" frameBorder="0"></iframe>
            </div>
        </div>

        <div className={cls.block}>
            <h2>Реквизиты</h2>
            <h3>ИП Винская Ирина Сергеевна</h3>
            <div className={cls.table}>
                <div>ИНН</div>
                <div>502916763858</div>
                <div>Банк</div>
                <div>АО «АЛЬФА-БАНК»</div>
                <div>Бик</div>
                <div>044525593</div>
                <div>Номер счёта</div>
                <div>40802810402370016913</div>
                <div>Корр. счет</div>
                <div>30101810200000000593</div>
                <div>Адрес</div>
                <div>ул. Римского-Корсакова, д. 11, корп./ст. 6, кв./оф. 180, г. Москва</div>
            </div>

        </div>

    </div>
)